import { styled } from 'baseui'

export const Section = styled('section', {
  marginBottom: '2rem',
  ':last-child': { marginBottom: 0 },
})

export const SectionHeader = styled('div', {
  display: 'flex',
  alignItems: 'baseline',
  gap: '0.75rem',
  marginBottom: '1rem',
})

export const SectionTitle = styled('h2', ({ $theme }) => ({
  margin: 0,
  color: $theme.colors.primary,
  ...$theme.typography.HeadingMedium,
}))

export const SectionCount = styled('span', ({ $theme }) => ({
  color: $theme.colors.textMuted,
  ...$theme.typography.ParagraphSmall,
}))
